module.exports = __webpack_public_path__ + "media/images/box_help-84db9f7f03550e5539039460eb69cfb3.png";